import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider, Route } from 'react-router5';
import * as Actions from '../common/services/actions';
import configureStore from '../common/services/store';
import router from '../common/routes/router';
import OurStories from '../listings/our-stories/ourStories';

let store;

function OurStoriesApp() {
	return (
		<Provider store={store}>
			<RouterProvider router={router}>
				<OurStories />
			</RouterProvider>
		</Provider>
	);
}

export function renderOurStories(id) {
	if (!store) {
		store = configureStore(router);
	}
	store.dispatch(Actions.initialiseSettings('ourstories'));
	router.start(() => {
		ReactDOM.render(<OurStoriesApp />, document.getElementById(id));
	});
}
